module.exports = __webpack_public_path__ + "img/refrigerator.36e8bf78.svg";